module.exports = __webpack_public_path__ + "static/media/dollar.702185e5.svg";